var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"categoryview-container"},[_c('ThreadList',{attrs:{"thread-list":_vm.threadList,"is-loading":_vm.isLoading},on:{"load-more":_vm.handleLoadMore}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b4ac613","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/BookmarksView.vue
// module id = 735
// module chunks = 1